import DialogBase from 'components/dialog/Base'
import PropTypes from 'prop-types'
import { useContext, useCallback, useState } from 'react'

import { DialogCurrentJobContext, disableJob, actions, useDialogDispatch } from './useDialog'

const DialogCommon = ({ children }) => {
  /** @type { {currentJob: Job, preJob: Job} } */
  const { currentJob, preJob } = useContext(DialogCurrentJobContext)
  const dispatch = useDialogDispatch()
  const open = Boolean(currentJob)
  const { title, onAction, onCancel, /* message,*/ noClose, ...rest } =
    currentJob || (preJob && disableJob(preJob)) || {}
  const [loading, setLoading] = useState(false)

  const createHandler = useCallback(
    (onEvent) => {
      if (!onEvent) {
        return undefined
      }

      return async () => {
        setLoading(true)
        await onEvent()
        setLoading(false)
        dispatch(actions.finishJob())
      }
    },
    [dispatch],
  )

  const [handleCancel, handleAction] = [onCancel, onAction].map(createHandler)

  const handleClose = noClose ? undefined : handleCancel

  return (
    <DialogBase
      open={open}
      title={title}
      onClose={handleClose}
      onCancel={onCancel && handleCancel}
      onAction={onAction && handleAction}
      loading={loading}
      {...rest}
    >
      {children}
    </DialogBase>
  )
}

DialogCommon.propTypes = {
  children: PropTypes.node.isRequired,
}

export default DialogCommon
